import TextField from '@material-ui/core/TextField';
import { ErrorBag } from 'src/models/ErrorModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { FORM_ID } from 'src/models/FormModel';
import { CSSProperties, ReactNode } from 'react';

interface Props {
  disabled?: boolean,
  error?: Nullable<string>,
  form: FORM_ID,
  label?: string | ReactNode,
  name: string,
  onChange: (value: any, fieldname: any) => void,
  required?: boolean,
  value: string | number | undefined,
  multiline?: boolean,
  minRows?: number | string,
  maxRows?: number | string,
  size?: 'medium' | 'small' | undefined,
  margin?: 'dense' | 'normal' | undefined,
  inputProps?: any,
  type?: string,
  id?: string,
  style?: CSSProperties,
}

const FormTextField = (props: Props) => {
  const {
    disabled,
    error,
    form,
    name,
    label,
    onChange,
    required,
    value,
    multiline,
    minRows,
    maxRows,
    size,
    margin,
    inputProps,
    type,
    id,
    style,
  } = props;

  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const getError = () => {
    if (!!error) return error;
    if (errors[name]) return errors[name].join(',');
    return undefined;
  };

  return (
    <TextField
      style={style}
      variant="outlined"
      size={size}
      margin={margin || 'normal'}
      multiline={multiline}
      required={!!required}
      disabled={!!disabled}
      fullWidth
      minRows={minRows}
      maxRows={maxRows}
      id={id || name.concat('-id')}
      label={label}
      name={name}
      key={`textfield-${name}`}
      autoComplete={name}
      onChange={(e) => onChange(e.target.value as string, name)}
      error={!!getError()}
      helperText={getError()}
      value={value || ''}
      inputProps={inputProps}
      type={type} />
  );
};

export default FormTextField;
